module.exports = __webpack_public_path__ + "static/media/Paraphrase_1purple.fa68da09.png";